import React, { useEffect, useState } from "react";


import SelectFilterChip from "../../../../masters/studentFinancials/paymentCollection/SelectFilterChip";
// import SearchInput from "views/pages/manage/masters/onlinePackage/SearchInput";
// import AInput from "../../common/formFeilds/customInput/AInput";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { inputHeight } from "views/pages/manage/edpOps/stockManagement/stockTxns/SearchByOtherDetailsForm";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { FaCheckSquare } from "react-icons/fa";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { isAlphabet } from "views/pages/manage/gateAttendance/constant";
import { isNumber } from "views/pages/manage/gateAttendance/constant";
import SelectSearchInputParam from "views/pages/manage/edpOps/studentSerach/SelectSearchInputParam";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import CustomDatePicker from "views/pages/manage/common/commonComponents/CustomDatePicker";
import { InputLabel } from "@mui/material";
import moment from "moment";
import { InputLabelStyle } from "views/pages/manage/common/form-fields-mui/AMultiSelect";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import { emptyReq } from "./contant";
// import { tgetFilterCount } from "../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
// import { isAlphabet, isNumber } from "../../gateAttendance/constant";


const ExamSearchForm = ({
    isLoading,
    setIsLoading,
    globalFilter,
    setGlobalFilter,
    isListVisible,
    setListVisible,
    filterType,
    setFilterType,
    selectedFilter,
    setSelectedFilter,
    setFilterCount,
    dropdownData,
    searchHandler = () => { },
    crossHandler = () => { },
    setDropdownData

}) => {
    const [searchCriteria, setSearchCriteria] = useState("psid");
    const [inputVal, setInputVal] = useState("");

    useEffect(() => {
        getDropdowns()
    }, [])

    const getDropdowns = async () => {
        
    }

    const checkBoxChangeHandler = (newSearchCriteria) => {
        setInputVal("");
        setGlobalFilter({})
        setSearchCriteria(newSearchCriteria);
    };


    const callback = () => {
        setInputVal("");
        setGlobalFilter(emptyReq)
    };
    console.log(globalFilter)
    const isValidInput = () => {
        if (searchCriteria === "psid" && inputVal?.length !== 11) {
            failureToast("PSID must be 11 digits long!");
            return false;
        }

        if (searchCriteria === "rollNumber" && inputVal?.length !== 12) {
            failureToast("Roll Number must be 12 digits long!");
            return false;
        }
        return true;
    };

    const handleSearch = () => {
        isValidInput() &&
            searchHandler({
                [searchCriteria]: inputVal,
            });
            setGlobalFilter({[searchCriteria]: inputVal})
    };

    const handleCrossIconClick = () => {
        setGlobalFilter((prev) => (emptyReq));
        setInputVal("");
    };

    const onKeyDown = (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            handleSearch()
        }
    };


    const resetHandler = () => {
        setGlobalFilter((prev) => (emptyReq));
    }

    const formHandler = (key, value) => {
        setGlobalFilter((prev) => ({ ...prev, [key]: value ?? [], searchValue: "" }));
    };

    const styles = {
        display: "grid",
        gridTemplateColumns:
            "repeat(6,minmax(100px, 1fr)) minmax(130px, 1fr)minmax(50px, 1fr)",
        gap: "16px",
        alignItems: "center",
    };
    const applySearchHandler = () => {
        // const req = {
        //     id: isNumber(globalFilter?.searchValue) ? (globalFilter?.searchValue).trim() : "",
        //     name: isAlphabet(globalFilter?.searchValue) ? (globalFilter?.searchValue).trim() : "",
        // }
        // if (req?.id || req?.name) {
           
        // }
        searchHandler(globalFilter)
    }

    return (
        <>
            <SelectFilterChip
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
                cb={callback}
            />

            <SelectSearchInputParam
                searchInputParam={searchCriteria}
                setSearchInputParam={checkBoxChangeHandler}
                isHideName
                disabled={selectedFilter !== "SINGLE"}
                isHideAppplicationId
                isRollNo
            />

            <div style={{ width: "fit-content" }}>
                <AInput
                    placeholder={`Search by ${searchCriteria === "psid" ? "PSID" : "Roll Number"
                        }`}
                    style={{ height: "45px", width: "535px", marginTop: "4px" }}
                    value={inputVal}
                    handler={(val) => setInputVal(val)}
                    onKeyDown={onKeyDown}
                    crossIcon={true}
                    rightSearchIcon={true}
                    searchIconClickHandler={handleSearch}
                    crossHandler={handleCrossIconClick}
                    disabled={selectedFilter !== "SINGLE"}
                    onKeyPress={(e) => {
                        if (!/^[0-9]*$/.test(String.fromCharCode(e.charCode))) {
                            e.preventDefault();
                            return;
                        }
                    }}
                    maxLength={searchCriteria === "psid" ? 11 : 12}
                />
            </div>
            <div style={styles} className="mt-4 mb-2">
                <div>
                    <AAutoComplete
                        label="Business Area*"
                        height={inputHeight}
                        placeholder="Select"
                        items={dropdownData?.bu ?? []}
                        currentValue={globalFilter?.businessArea}
                        handleChange={(value) => {
                            formHandler("businessArea", value)
                        }}
                        isMulti={false}
                        isDisabled={selectedFilter !== "MASTER"}
                    />
                </div>
                <div>
                    <AAutoComplete
                        label="Term*"
                        height={inputHeight}
                        placeholder="Select"
                        items={dropdownData?.term ?? []}
                        currentValue={globalFilter?.term}
                        handleChange={(value) => {
                            formHandler("term", value)
                        }}
                        isMulti={false}
                        isDisabled={selectedFilter !== "MASTER"}
                    />
                </div>
                <div>
                    <AAutoComplete
                        label="Course ID*"
                        height={inputHeight}
                        placeholder="Select"
                        isMulti={true}
                        items={dropdownData?.courseId ?? []}
                        currentValue={globalFilter?.courseId}
                        isShowCount={true}
                        handleChange={(value) => {
                            formHandler("courseId", value)
                        }}
                        isDisabled={selectedFilter !== "MASTER"}
                    />
                </div>
                <div>
                    <AAutoComplete
                        label="Exam code*"
                        height={inputHeight}
                        placeholder="Select"
                        isMulti={true}
                        items={dropdownData?.examCode ?? []}
                        currentValue={globalFilter?.examCode}
                        isShowCount={true}
                        handleChange={(value) => {
                            formHandler("examCode", value)
                        }}
                        isDisabled={selectedFilter !== "MASTER"}
                    />
                </div>
                <div>
                    <CustomDatePickerV2
                        placeHolder="From"
                        minDate={dropdownData?.termStartDate}
                        maxDate={dropdownData?.termEndDate}
                        value={
                            globalFilter?.examDateFrom ? moment(globalFilter?.examDateFrom) : null
                        }
                        label="Exam date"
                        handler={(index, date, keyName) => {
                            formHandler("examDateFrom", date);
                            formHandler("examDateTo", '');
                        }}
                        disabled={selectedFilter !== "MASTER"}
                    />
                </div>
                <div style={{ marginTop: '30px' }}>
                    <CustomDatePickerV2
                        placeHolder="To"
                        value={globalFilter?.examDateTo ? moment(globalFilter?.examDateTo) : null}
                        handler={(index, date, keyName) => {
                            formHandler("examDateTo", date);
                        }}
                        minDate={globalFilter?.examDateFrom}
                        maxDate={dropdownData?.termEndDate}
                        disabled={selectedFilter !== "MASTER"||!globalFilter?.examDateFrom}
                    />
                </div>
                <div className="d-flex" style={{ marginTop: '30px' }}>
                    {console.log('global',globalFilter)}
                    <AButton
                        variant={"primary_filled"}
                        onClick={() => {applySearchHandler() }}
                        disabled={selectedFilter !== "MASTER"||
                             !(globalFilter?.businessArea 
                             && globalFilter?.term
                            && globalFilter?.courseId.length>0
                            && globalFilter?.examCode.length>0>0)}
                        updatedStyle={{ minWidth: "150px" }}
                    >
                        Next
                    </AButton>

                    <AButton
                        variant={"danger_filled"}
                        disabled={selectedFilter !== "MASTER"}
                        onClick={() => { resetHandler() }}
                    >
                        Reset
                    </AButton>
                </div>
            </div>


        </>
    )
}

export default ExamSearchForm;   